import SubTitle from '@/pages/WgqAllMaps/components/SubTitle';
import { getDefaultTimeByWaterTrend } from '@/pages/WgqAllMaps/utils';
import { DoubleRightOutlined } from '@ant-design/icons';
import { Button, EchartsWithTheme, Empty, useTheme } from '@maxtropy/components';
import dayjs from 'dayjs';
import { isNil } from 'lodash-es';
import { useContext, useEffect, useMemo, useState } from 'react';
import { DateTypeByWater, ShareDataWaterMapContext } from '../..';
import { ShareConfigDataWaterContext } from '../../../..';
import { useRequest } from 'ahooks';
import { apiV2WaterMapDataTrendPost } from '@maxtropy/device-customer-apis-v2';
import { getChartNoWorkingOption, getChartOption } from './charts';
import styles from './index.module.scss';

const EnergyConsumptionTrends = () => {
  const theme = useTheme();
  const { timeResolution, value } = useContext(ShareDataWaterMapContext);
  const { configDetail } = useContext(ShareConfigDataWaterContext);
  const [energyStr, setEnergyStr] = useState<string>(''); // 传参

  // 用能趋势
  const { data: trendData, loading } = useRequest(
    async () => {
      return await apiV2WaterMapDataTrendPost({
        unitId: configDetail?.energyUnitId1,
        groupId: configDetail?.energyGroupId1,
        dataQueryPeriodIds: configDetail?.periodId ? [configDetail?.periodId] : undefined,
        type: timeResolution,
        startTime: dayjs(getDefaultTimeByWaterTrend(timeResolution!, value).startTime).format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs(getDefaultTimeByWaterTrend(timeResolution!, value).endTime).format('YYYY-MM-DD HH:mm:ss'),
      });
    },
    {
      ready: !!timeResolution && !!value && !!configDetail,
      refreshDeps: [timeResolution, value, configDetail],
    }
  );

  useEffect(() => {
    if (!configDetail) return;
    let str = '';
    if (!isNil(configDetail?.energyGroupId1)) {
      str += `energyGroupId=${configDetail?.energyGroupId1}`;
    }
    if (!isNil(configDetail?.energyUnitId1)) {
      str += `&unitId=${configDetail?.energyUnitId1}`;
    }
    setEnergyStr(str);
  }, [configDetail]);

  // 图表（总用量）
  const chartOption = useMemo(() => {
    return getChartOption(trendData, timeResolution);
  }, [trendData, timeResolution]);

  // 图表（非工作时段-用量）
  const chartNoWorkingOption = useMemo(() => {
    return getChartNoWorkingOption(trendData, timeResolution);
  }, [trendData, timeResolution]);

  const routeStr = useMemo(() => {
    if (timeResolution === DateTypeByWater.YEAR) {
      const startDate = dayjs(getDefaultTimeByWaterTrend(timeResolution!, value).startTime).format('YYYY');
      const endDate = dayjs(getDefaultTimeByWaterTrend(timeResolution!, value).endTime).format('YYYY');
      return `&currentYear=true&startDate=${startDate}&endDate=${endDate}`;
    } else {
      const startDate = dayjs(getDefaultTimeByWaterTrend(timeResolution!, value).startTime).format('YYYYMM');
      const endDate = dayjs(getDefaultTimeByWaterTrend(timeResolution!, value).endTime).format('YYYYMM');
      return `&currentMonth=true&startDate=${startDate}&endDate=${endDate}`;
    }
  }, [timeResolution, value]);

  return (
    <SubTitle
      title="用水趋势"
      extraContent={
        <Button
          type="link"
          style={{ padding: 0 }}
          onClick={() => {
            window.open(`${window.ENERGY}/layout/home?${energyStr}${routeStr}`, '_blank');
          }}
        >
          <DoubleRightOutlined className="translationStyles" />
        </Button>
      }
    >
      <div className={styles.echarts_wrapper}>
        <EchartsWithTheme
          empty={{
            isShowEmpty: !trendData,
            emptyNode: <Empty />,
          }}
          loading={loading}
          theme={theme}
          style={{ height: 200 }}
          option={chartOption}
        />
      </div>
    </SubTitle>
  );
};

export default EnergyConsumptionTrends;
